import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getUtcDate } from '../../../shared/functions/date.functions';
import * as fromAppointment from '../reducer/appointments.reducer';

export const selectAppointmentFeature = createFeatureSelector<fromAppointment.AppointmentState>(
  fromAppointment.appointmentFeatureKey
);

const { selectAll } = fromAppointment.appointmentAdapter.getSelectors();

export const selectAppointments = createSelector(selectAppointmentFeature, selectAll);

export const selectError = createSelector(selectAppointmentFeature, state => state.baseState.error);

export const selectIsLoading = createSelector(selectAppointmentFeature, state => state.baseState.isLoading);

export const selectIsLoadingUpcomingAppointments = createSelector(
  selectAppointmentFeature,
  state => state.isLoadingUpcomingAppointments
);

export const selectIsLoadingPastAppointments = createSelector(
  selectAppointmentFeature,
  state => state.isLoadingPastAppointments
);

export const selectIsLoadingMorePastAppointments = createSelector(
  selectAppointmentFeature,
  state => state.isLoadingMorePastAppointments
);

export const selectPageNumber = createSelector(selectAppointmentFeature, state => state.baseState.pageNumber);

export const selectIsAtEndOfData = createSelector(selectAppointmentFeature, state => state.baseState.isAtEndOfData);

export const selectSortColumn = createSelector(selectAppointmentFeature, state => state.baseState.sortBy?.value);

export const selectNextAppointment = createSelector(selectAppointments, appointments =>
  appointments.length === 0 ? null : appointments[0]
);

export const selectUpcomingAppointments = createSelector(selectAppointments, appointments => {
  const upcomingAppointments = appointments.filter(
    appointment => new Date(appointment.dateOfServiceUtc) > getUtcDate()
  );
  return upcomingAppointments.length === 0 ? null : upcomingAppointments;
});

export const selectPastAppointments = createSelector(selectAppointments, appointments => {
  const pastAppointments = appointments.filter(appointment => new Date(appointment.dateOfServiceUtc) < getUtcDate());
  return pastAppointments.length === 0 ? null : pastAppointments;
});
